import * as React from "react";

export const LevelFive = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M35.16 21.932c0 7.306-5.922 13.229-13.228 13.229S8.703 29.238 8.703 21.932c0-7.306 5.923-13.229 13.229-13.229 7.306 0 13.229 5.923 13.229 13.229Zm-23.49 0c0 5.668 4.594 10.262 10.262 10.262S32.194 27.6 32.194 21.932 27.6 11.67 21.932 11.67 11.67 16.264 11.67 21.932Z"
    />
    <path
      stroke="#fff"
      strokeWidth={3.079}
      d="M16.848 26.293V17.57h9.75v8.723h-9.75Z"
    />
  </svg>
);
